import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import moment from "moment";
import Button from "@mui/material/Button";
import DownloadIcon from "@mui/icons-material/Download";
import { Grid } from "@mui/material";
import {
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarDensitySelector,
} from "@mui/x-data-grid";
import { DataFormat } from "../../../../_helpers/commonFunctions";
import Axios from "axios";
import { API_URL_LMS, API_URL_ADMIN,API_URL_USER } from "../../../../Constant/index";
import ExportExcelPopup from "../../../../components/exportPopup/ExportExcelPopup";
import { RenderCellExpand } from "../../../../components/datagridtooltip/DataGridToolTip";
import DataGridProMUI from "../../../../components/DataGrid/DataGridProMUI";
import {
  convertToCurrencyFormat,
  convertToCurrencyFormatQuantaty,
} from "../../../../_helpers";
import Controls from "./Controls";
import { useForm } from "../../../../components/Form/FormComponent";
import { onExportExcel } from "../../../../_helpers/exportExcel";
import { isPermission, authorizedMessage } from "../../../../_helpers/commonAPI";
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },

  container: {
    maxHeight: "calc(90vh - 210px)",
  },

  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
}));

const DEALER_NUMBER = "Dealer Number";
const SUB_DEALER_NUMBER = "Sub Dealer Number";
const BILLING_NUMBER = "Billing Number";
const PRODUCT_NUMBER = "Product Number";

export default function DealerActivityPointTable(props) {
  const classes = useStyles();
  // OPTIONS FOR COMPANY

  const COMPANY_LIST = [
    // { code: "All", description: "All" },
    { code: "SCCC", description: "SCCC" },
    { code: "CONWOOD", description: "CONWOOD" },
  ];

  // OPTIONS FOR ACTIVITY TYPE
  const ALLOCATION_TYPE_LIST = [
    // { code: "All", description: "All" },
    { code: "Auto", description: "Auto Allocated" },
    { code: "Manual", description: "Manual Allocated" },
  ];
  const DATE_ONE_YEAR_BACK = new Date(
    new Date().setFullYear(new Date().getFullYear() - 1)
  );
  const INITIAL_STATE = {
    company: "All",
    allocationType: "All",
    startDate: DATE_ONE_YEAR_BACK,
    endDate: new Date(),
    dealerNumber: "",
    subDealerNumber: "",
    billingNumber: "",
    productNumber: "",
  };

  let [filterObj, setFilterObj] = useState(INITIAL_STATE);
  const [filteredData, setFilteredData] = useState([]);
  const [dealerNumer, setDealerNumer] = useState([]);
  const [subDealerNumber, setSubDealerNumber] = useState([]);
  const [billingNumber, setBillingNumber] = useState([]);
  const [productNumber, setProductNumber] = useState([]);
  const [resetCount, setCount] = useState(0);
  const [filterErr, setFilterErr] = useState({});
  const [pageSize, setPageSize] = useState(25);
  const [fileUrl, setFileUrl] = useState("");
  const [exportFiles, setExportFiles] = useState([]);
  const [open, setOpen] = useState(false);
  const [exportState, setExportState] = useState("Export");
  const [gridData, setGridData] = useState([]);
  const [searchedRows, setSearchedRows] = useState(null)
  const excelFormating = [
    { expirationDate: "date" },
    { creationDate: "date" },
    { billingDate: "date" },
  ];
  const ExpFilecolHeadings = [
    [
      "Company",
      "Dealer Number",
      "Dealer Name",
      "Sub Dealer Number",
      "Sub Dealer Name",
      "Billing Number",
      "Billing Date",
      "Product Number",
      "Product Name",
      "Billing Month",
      "Billing Year",
      "Allocated",
      "Point Received",
      "Expiration Date",
      "Create Date",
      "Allocation Type",
    ],
  ];
  const ExpFilecolKeys = [
    "company",
    "customerId",
    "customerName",
    "subDealerId",
    "subDealerName",
    "billingNumber",
    "billingDate",
    "productCode",
    "productName",
    "billingMonth",
    "billingYear",
    "selectedQuantity",
    "pointsReceived",
    "expirationDate",
    "creationDate",
    "allocationType",
  ];

  const clearAll = () => {
    setFilterObj(INITIAL_STATE);
    setCount((current) => current + 1);
    setFilteredData([]);
    setFilterErr({});
    setValues(INITIAL_STATE);
  };

  const [selectedValue, setSelectedValue] = React.useState(null);

  const [showLoading, setShowLoading] = useState(false);

  //export same as report starts here
  const onExportClick = () => {
    const url = `export/volume-allocation/report`;
    setExportState("Exporting...");
    let filters = {
      fromDate: filterObj.startDate
        ? moment(filterObj.startDate).format("DD-MM-YYYY")
        : null,
      toDate: filterObj.endDate
        ? moment(filterObj.endDate).format("DD-MM-YYYY")
        : null,
      allocationType: filterObj.allocationType ? filterObj.allocationType : null,
      subDealerNumber: values.subDealerNumber ? values.subDealerNumber : null,
      dealerNumber: values.dealerNumber ? values.dealerNumber : null,
      company: filterObj.company === "All" ? null : filterObj.company,
      billingNumber: values.billingNumber ? values.billingNumber : null,
      productNumber: values.productNumber ? values.productNumber : null,
      // company: null,
      // dealerNumber: null,
      // subDealerNumber: null,
      // billingNumber: null,
      // productNumber: null,
      // fromDate: "03-01-2022",
      // toDate: "03-01-2023",
      // allocationType: "All",
      // search: null,
    };
    Axios({
      method: "POST",
      url: API_URL_LMS + url,
      data: filters,
      headers: {
        "Content-Type": "application/json",
        "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
        "X-SOLD-TO-ID": localStorage.getItem("CustomerNumber"),
      },
    })
      .then(async (response) => {
        setExportState("Export");
        setOpen(true);
        setFileUrl(response.data.data);
        exportExcelFile(response.data.data);
      })
      .catch((err) => {
        setOpen(true);
        setExportState("Export");
      });
  };

  function exportExcelFile(file_url) {
    setExportFiles([]);
    Axios({
      method: "GET",
      url: API_URL_LMS + `export/bucket?folderName=${file_url}`,
      headers: {
        "Content-Type": "application/json",
        "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
        "X-SOLD-TO-ID": localStorage.getItem("CustomerNumber"),
      },
    })
      .then(async (response) => {
        const newRes = Array.isArray(response.data.data)
          ? response.data.data
          : [];
        setExportFiles(newRes);
      })
      .catch((err) => {
        // setExportState({ btnName: "EXPORT" });
      });
  }

  const filterOnChange = (e) => {
    setFilterErr({});
    setFilterObj({ ...filterObj, [e.target.name]: e.target.value });
  };

  const validate = () => {
    let temp = {};
    if ("endDate" in filterObj && filterObj.endDate != null) {
      temp.startDate =
        filterObj.startDate > filterObj.endDate
          ? "Create Date From Should be lesser than Create Date TO"
          : "";
    }
    setFilterErr({ ...temp });
    return Object.values(temp).every((eachFieldErr) => eachFieldErr == "");
  };

  // useform is a reusable component for forms
  // for single controll real time validation of form pass true as 2nd parameter and validate function as 3rd parameter
  const { values, setValues, handleInputChange, errors, setErrors } = useForm(
    // INITIAL_FORM_VALUES,
    INITIAL_STATE,
    true,
    validate
  );

  const getdealer = (e) => {
    const requestOptions = {
      headers: {
        "Content-Type": "application/json",
        "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
      },
    };
    Axios.get(
      API_URL_ADMIN + `search/dealerNumberSearch?searchText=${e}`,
      requestOptions
    )
      .then((response) => {
        const dealerSearchDataData =
          response.data &&
          response.data.data &&
          response.data.data.length &&
          response.data.data.map((dealerItem) => {
            return {
              label: dealerItem,
              value: dealerItem,
            };
          });
        setDealerNumer(dealerSearchDataData);
      })
      .catch((error) => {});
  };

  const getSubdealer = (e) => {
    const requestOptions = {
      headers: {
        "Content-Type": "application/json",
        "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
      },
    };
    Axios.get(
      API_URL_ADMIN + `search/subdealerNumberSearch?searchText=${e}`,
      requestOptions
    )
      .then((response) => {
        const subDealerSearchData =
          response.data &&
          response.data.data &&
          response.data.data.length &&
          response.data.data.map((dealerItem) => {
            return {
              label: dealerItem,
              value: dealerItem,
            };
          });
        setSubDealerNumber(subDealerSearchData);
      })
      .catch((error) => {});
  };

  const getBillingNumber = (e) => {
    const requestOptions = {
      headers: {
        "Content-Type": "application/json",
        "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
      },
    };
    Axios.get(
      API_URL_LMS + `admin/billingNumberSearch?searchText=${e}`,
      requestOptions
    )
      .then((response) => {
        const billingData =
          response.data &&
          response.data.data &&
          response.data.data.length &&
          response.data.data.map((dealerItem) => {
            return {
              label: dealerItem,
              value: dealerItem,
            };
          });
        setBillingNumber(billingData);
      })
      .catch((error) => {});
  };

  const getProductNumber = (e) => {
    const requestOptions = {
      headers: {
        "Content-Type": "application/json",
        "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
      },
    };
    Axios.get(
      API_URL_LMS + `admin/productNumberSearch?searchText=${e}`,
      requestOptions
    )
      .then((response) => {
        const productData =
          response.data &&
          response.data.data &&
          response.data.data.length &&
          response.data.data.map((dealerItem) => {
            return {
              label: dealerItem,
              value: dealerItem,
            };
          });
        setProductNumber(productData);
      })
      .catch((error) => {});
  };

  const onFilterSearch = async() => {
    const isAllow = await isPermission("Master-LoyaltyReports-VolumeAllocation-view")
    if (!isAllow) {
        toast.success(authorizedMessage, {
            position: toast.POSITION.TOP_RIGHT
        });
        return 0;
    }
    if (validate()) {
      const requestOptions = {
        headers: {
          "Content-Type": "application/json",
          "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
        },
      };
      setShowLoading(true);
      Axios.get(
        API_URL_LMS +
          `admin/volumeAllocateTransactions?fromDate=${
            filterObj.startDate
              ? moment(filterObj.startDate).format("DD-MM-YYYY")
              : null
          }&toDate=${
            filterObj.endDate
              ? moment(filterObj.endDate).format("DD-MM-YYYY")
              : null
          }&allocationType=${filterObj.allocationType}&dealerNumber=${
            // filterObj.dealerNumber ? handleZero(filterObj.dealerNumber) : null
            values.dealerNumber ? values.dealerNumber : null
          }&subDealerNumber=${
            // filterObj.subDealerNumber ? filterObj.subDealerNumber : null
            values.subDealerNumber ? values.subDealerNumber : null
          }&company=${
            filterObj.company === "All" ? null : filterObj.company
          }&billingNumber=${
            // filterObj.billingNumber ? filterObj.billingNumber : null
            values.billingNumber ? values.billingNumber : null
          }&productNumber=${
            // filterObj.productNumber ? filterObj.productNumber : null
            values.productNumber ? values.productNumber : null
          }&isDealer=${false}&userId=${(
            localStorage.getItem('userData') && JSON.parse(localStorage.getItem('userData')).userId) ?
            JSON.parse(localStorage.getItem('userData')).userId : ''}&customer_number=${null}`,
        requestOptions
      )
        .then((response) => {
          setShowLoading(false);
          setFilteredData(
            response.data && response.data.data ? response.data.data : []
          );
        })
        .catch((error) => {
          setShowLoading(false);
          // setExportState({ btnName: "EXPORT" });
        });
    }
  };

  // function for auto select that is pass into the AutoSelectSearch Components

  function autoSelectFn(selected, name) {
    setFilterObj({
      ...filterObj,
      [name]: selected && selected.value ? selected.value : "",
    });
    // setFilterObj({ ...filterObj, [selected.name]: selected.value });
  }
  const columns = [
    {
      field: "company",
      headerAlign: "center",
      align: "center",
      width: 150,
      headerName: "Company",
    },
    {
      field: "customerId",
      headerAlign: "center",
      align: "center",
      width: 150,
      headerName: "Dealer Number",
      renderCell: ({ row }) => {
        return <div>{row.customerId ? row.customerId : ""}</div>;
      },
    },
    {
      field: "customerName",
      headerAlign: "center",
      align: "left",
      width: 150,
      headerName: "Dealer Name",
      renderCell: RenderCellExpand,
    },
    {
      field: "subDealerId",
      headerAlign: "center",
      align: "center",
      width: 150,
      headerName: "Sub Dealer Number",
      renderCell: ({ row }) => {
        return <div>{row.subDealerId ? DataFormat(row.subDealerId) : ""}</div>;
      },
    },
    {
      field: "subDealerName",
      headerAlign: "center",
      align: "left",
      width: 150,
      headerName: "Sub Dealer Name",
      renderCell: RenderCellExpand,
    },
    {
      field: "billingNumber",
      headerAlign: "center",
      align: "center",
      width: 150,
      headerName: "Billing Number",
    },
    {
      field: "billingDate",
      headerAlign: "center",
      align: "center",
      width: 100,
      headerName: "Billing Date",
      type: "date",
      valueFormatter: (row) => {
        return row.value && row.value !== null
          ? moment(new Date(row.value)).format("DD-MM-yyyy")
          : "";
      },
    },
    {
      field: "productCode",
      headerAlign: "center",
      align: "center",
      width: 200,
      headerName: "Product Number",
      renderCell: ({ row }) => {
        return <div>{row.productCode ? DataFormat(row.productCode) : ""}</div>;
      },
    },
    {
      field: "productNameEN",
      headerAlign: "center",
      align: "left",
      width: 200,
      headerName: "Product Name",
      renderCell: RenderCellExpand,
    },
    {
      field: "billingMonth",
      headerAlign: "center",
      align: "center",
      width: 150,
      headerName: "Billing Month",
      renderCell: ({ row }) => {
        // return <div>{moment(row.billingMonth).format("MMMM")}</div>;
        return (
          <div>
            {row.billingMonth ? moment(row.billingMonth).format("MM") : null}
          </div>
        );
      },
    },
    {
      field: "billingYear",
      headerAlign: "center",
      align: "center",
      width: 150,
      headerName: "Billing Year",
    },
    {
      field: "billingQty",
      headerAlign: "center",
      align: "right",
      width: 150,
      headerName: "Allocated",
      format: '#,##0.000',
      renderCell: ({ row }) => {
        return (
          <div>
            {row.billingQty
              ? convertToCurrencyFormatQuantaty(row.billingQty)
              : null}
          </div>
        );
      },
    },
    {
      field: "pointsReceived",
      headerAlign: "center",
      align: "right",
      width: 150,
      headerName: "Point Received",
      format: '#,##0.00',
      renderCell: ({ row }) => {
        return (
          <div>
            {row.pointsReceived != null
              ? convertToCurrencyFormat(row.pointsReceived)
              : ""}
          </div>
        );
      },
    },
    {
      field: "expirationDate",
      headerAlign: "center",
      align: "center",
      width: 130,
      headerName: "Expiration Date",
      type: "date",
      format: 'DD-MM-yyyy',
      valueFormatter: (row) => {
        return row.value && row.value !== null
          ? moment(new Date(row.value)).format("DD-MM-yyyy")
          : "";
      },
    },
    {
      field: "creationDate",
      headerAlign: "center",
      align: "center",
      width: 150,
      headerName: "Create Date",
      type: "date",
      format: 'DD-MM-yyyy',
      valueFormatter: (row) => {
        return row.value && row.value !== null
          ? moment(new Date(row.value)).format("DD-MM-yyyy")
          : "";
      },
    },
    {
      field: "allocationType",
      headerAlign: "center",
      align: "center",
      width: 150,
      headerName: "Allocation Type",
    },
    { field: 'billDate', headerName: 'billDate', hide: true },
    { field: 'cDate', headerName: 'cDate', hide: true },
    { field: 'exDate', headerName: 'exDate', hide: true },
    { field: 'bm', headerName: 'billing month', hide: true },
    { field: 'by', headerName: 'billing year', hide: true },
    { field: 'a', headerName: 'allocated', hide: true },
    { field: 'pr', headerName: 'allocated', hide: true },
  ];

  React.useEffect(() => {
    const url = `mds/audit-event/create`;
    let details = {
      eventType: "Report_Visit",
      source: "Volume Allocation Report",
      userId: (localStorage.getItem('userData') && JSON.parse(localStorage.getItem('userData')).userId) ?
        JSON.parse(localStorage.getItem('userData')).userId : '',
      customer_number: '',
    };

    Axios({
      method: "POST",
      url: API_URL_USER + url,
      data: details,
      headers: {
        "Content-Type": "application/json",
        "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
        "X-SOLD-TO-ID": localStorage.getItem("CustomerNumber"),
      },
    })
      .then(async (response) => {
      })
      .catch((err) => {
      });
  }, [])

  React.useEffect(() => {
    const gridData =
      filteredData &&
      filteredData.map((item, index) => {
        return {
          ...item,
          // billingDateStr : millisecondsToStringDate(item.billingDate,DATE_FORMAT),
          // expireDateStr : millisecondsToStringDate(item.expirationDate,DATE_FORMAT),
          // creationDateStr : millisecondsToStringDate(item.creationDate,DATE_FORMAT)
          // createDateInMileSecond: new Date(item.createDateInMileSecond),
          expirationDate:
            item.expirationDate != null ? new Date(item.expirationDate) : "",
          creationDate:
            item.creationDate != null ? new Date(item.creationDate) : "",
          billingDate:
            item.billingDate != null ? new Date(item.billingDate) : "",
          billingNumber: item.billingNumber != null ? +item.billingNumber : "",
          subDealerId: item.subDealerId != null ? +item.subDealerId : "",
          billDate:item.billingDate != null ?  moment(new Date(item.billingDate)).format("DD-MM-yyyy") : "",
          bm:item.billingDate != null ?  moment(new Date(item.billingDate)).format("MM") : "",
          by:item.billingDate != null ?  moment(new Date(item.billingDate)).format("yyyy") : "",
          a:convertToCurrencyFormatQuantaty(item.billingQty),
          cDate: item.creationDate != null ? moment(new Date(item.creationDate)).format("DD-MM-yyyy") : "",
          exDate: item.expirationDate != null ? moment(new Date(item.expirationDate)).format("DD-MM-yyyy") : "",
          pr: convertToCurrencyFormat(item.pointsReceived)
        };
      });
    setGridData(gridData);
  }, [filteredData]);

  const CustomToolbar = () => {
    return (
      <GridToolbarContainer>
        <GridToolbarColumnsButton />
        <GridToolbarDensitySelector />
        <div className="ExportAndSearchContainer">
          <Button
            variant="outlined"
            startIcon={<DownloadIcon />}
            onClick={onExportClick}
          >
            {exportState.btnName}
          </Button>
        </div>
      </GridToolbarContainer>
    );
  };

  function modifyColumns(columns) {
    columns = columns.filter((item)=>!["billDate", "bm", "by", "a", "cDate", "exDate", "pr"].includes(item.field))
    return columns.map((item) => {
      return ({
        label: item.headerName,
        value: item.field,
        ...item
      })
    })
  }

  function modifyRows(rowdata) {
    // let filteredRow = searchedRows.map((item) => item.model);
    let filteredRow = rowdata.map((item) => item.model);
    const data = filteredRow.map((item) => {
      return ({
        ...item,
        // creationDate : item.creationDate ? new Date(item.creationDate) :""
      })
    })
    return data
  }

  function callExcelExport(data){
    const fileName = `Volume_Allocation_Report_${moment(new Date()).format("DDMMyyyy")}`;
    const sheetName = `Volume_Allocation_Report`;
    onExportExcel(modifyColumns(columns), modifyRows(data), fileName, sheetName)
  }


  return (
    <>
      <div className={classes.root}>
        <Paper className={classes.paper}>
          <div className="myFirstT mt-1">
            {/* Filter And Searching Components here */}

            <div className="pCalFormControll">
              <Grid container spacing={2} columns={10}>
                <Grid item sm={5} md={2} xs={12} className="SelectRightPadding">
                  <Controls.Select
                    name="company"
                    label="Company"
                    value={filterObj && filterObj.company}
                    onChange={filterOnChange}
                    optionCode="code"
                    optionLabel="description"
                    options={COMPANY_LIST}
                    minWidth="100%"
                  />
                </Grid>

                <Grid item sm={5} md={2} xs={12} className="AutoComplete">
                  <Controls.Input
                    name="dealerNumber"
                    label={DEALER_NUMBER}
                    value={values.dealerNumber}
                    onChange={handleInputChange}
                    size="small"
                    variant="standard"
                  />
                </Grid>

                <Grid item sm={5} md={2} xs={12} className="AutoComplete">
                  <Controls.Input
                    name="subDealerNumber"
                    label={SUB_DEALER_NUMBER}
                    value={values.subDealerNumber}
                    onChange={handleInputChange}
                    size="small"
                    variant="standard"
                  />
                </Grid>

                <Grid item sm={5} md={2} xs={12} className="AutoComplete">
                  <Controls.Input
                    name="billingNumber"
                    label={BILLING_NUMBER}
                    value={values.billingNumber}
                    onChange={handleInputChange}
                    size="small"
                    variant="standard"
                  />
                </Grid>

                <Grid item sm={5} md={2} xs={12} className="AutoComplete">
                  <Controls.Input
                    name="productNumber"
                    label={PRODUCT_NUMBER}
                    value={values.productNumber}
                    onChange={handleInputChange}
                    size="small"
                    variant="standard"
                  />
                </Grid>

                <Grid item sm={5} md={2} xs={12} className="SelectRightPadding">
                  <Controls.DatePicker
                    name="startDate"
                    label="Create Date From"
                    value={
                      filterObj && filterObj.startDate
                        ? filterObj.startDate
                        : DATE_ONE_YEAR_BACK
                    }
                    maxDate={new Date()}
                    onChange={filterOnChange}
                    style={{ width: "100%" }}
                    error={filterErr.startDate}
                  />
                </Grid>
                <Grid item sm={5} md={2} xs={12} className="SelectRightPadding">
                  <Controls.DatePicker
                    name="endDate"
                    label="Create Date To"
                    maxDate={new Date()}
                    value={
                      filterObj && filterObj.endDate
                        ? filterObj.endDate
                        : new Date()
                    }
                    onChange={filterOnChange}
                    style={{ width: "100%" }}
                  />
                </Grid>

                <Grid item sm={5} md={2} xs={12} className="SelectRightPadding">
                  <Controls.Select
                    name="allocationType"
                    label="Allocation Type"
                    value={filterObj && filterObj.allocationType}
                    onChange={filterOnChange}
                    optionCode="code"
                    optionLabel="description"
                    options={ALLOCATION_TYPE_LIST}
                    minWidth="100%"
                  />
                </Grid>
                <Grid item md xs display="flex" justifyContent="flex-end">
                  <Button
                    variant="contained"
                    className="btncolor"
                    size="small"
                    sx={{ m: 1 }}
                    onClick={onFilterSearch}
                  >
                    Search
                  </Button>
                  <Button
                    variant="outlined"
                    color="secondary"
                    size="small"
                    className="outlineButton"
                    sx={{ m: 1 }}
                    onClick={clearAll}
                  >
                    Clear All
                  </Button>
                </Grid>
              </Grid>
            </div>

            <div className="DataGridContainer">
              <ExportExcelPopup
                title={"Customer"}
                fileName={"customer"}
                setOpen={setOpen}
                open={open}
                exportExcelFile={exportExcelFile}
                fileUrl={fileUrl}
                exportFiles={exportFiles}
              />
              <DataGridProMUI
                rows={gridData}
                columns={columns}
                pageSize={pageSize}
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                loading={showLoading || props.loading}
                onExportClick={onExportClick}
                exportState={exportState}
                setSearchedRows={setSearchedRows}
                callExcelExport={callExcelExport}
                defaultStateChange={false}
              />
            </div>
          </div>
        </Paper>
      </div>
    </>
  );
}
